import { NgModule } from '@angular/core';
import { IconModule } from 'src/app/components/icon/icon.module';

import { SharedModule } from '../../shared/shared.module';
import { ListModule } from '../../components/list/list.module';

import { NotificationItemModule } from '../notification-item/notification-item.module';
import { NotificationsListComponent } from './notifications-list.component';

@NgModule({
  imports: [IconModule, ListModule, SharedModule, NotificationItemModule],
  declarations: [NotificationsListComponent],
  exports: [NotificationsListComponent],
})
export class NotificationsListModule {}
